const ELIGIBLE_CATEGORIES = {
	NAMES: [
		"Cost of Goods",
		"Product Cost",
		"Logistics - Inbound",
		"Logistics - Outbound",
		"Packaging",
		"B2B / Wholesale",
	] as const,
	IDS: ["659f47600c140c05def475d1", "66d05cd2f3eab3ab243bf92a", "659f47600c140c05def475cf"] as const,
};

const ELIGIBLE_INVOICE_CATEGORIES = {
	NAMES: ["B2B / Wholesale", "Retail"] as const,
};

export const TRIFFIN_CREDIT_PRODUCT_TERMS = {
	MONTHLY_FEE_RATE: 0.015,
	BULLET_FEE_RATE: 0.02,
	MIN_CREDIT_LIMIT: 20000,
	MAX_CREDIT_LIMIT: 2_000_000,
	MIN_CREDIT_PAYMENT_AMOUNT: 5000,
	MIN_REPAYMENT_MONTHS: 1,
	MAX_REPAYMENT_MONTHS: 6,
	/** Max repayment amount (GBP) for in-app Open Banking (Plaid). Keep aligned with `DIRECT_DEBIT_PAYMENT_LIMIT` in `@viable/direct-debit` so customers are not told to pay manually while DD still collects. */
	PLAID_LIMIT_IN_GBP: 50_000,
} as const;

export const TRIFFIN_CREDIT_ELIGIBLE_CATEGORY_NAMES = ELIGIBLE_CATEGORIES.NAMES;
export const TRIFFIN_CREDIT_ELIGIBLE_CATEGORY_IDS = ELIGIBLE_CATEGORIES.IDS;
export const TRIFFIN_CREDIT_ELIGIBLE_INVOICE_CATEGORY_NAMES = ELIGIBLE_INVOICE_CATEGORIES.NAMES;

export const TRIFFIN_CREDIT_CONSTANTS = {
	ELIGIBLE_CATEGORIES,
	ELIGIBLE_INVOICE_CATEGORIES,
};

export function isEligibleTriffinCreditCategory(categoryName?: string | null, categoryId?: string | null): boolean {
	if (categoryName) {
		const name = String(categoryName).trim();
		if ((ELIGIBLE_CATEGORIES.NAMES as readonly string[]).includes(name)) return true;
	}
	if (categoryId) {
		const id = String(categoryId).trim();
		if ((ELIGIBLE_CATEGORIES.IDS as readonly string[]).includes(id)) return true;
	}
	return false;
}
